import { Button, Modal, ModalBody, ModalContent, ModalFooter } from "@heroui/react";
import { BadgeCheckIcon } from "lucide-react";
import type { ManualClaimTxSuccess } from "../../state/types";
import { formatTimestamp } from "../../utils";
import { TxHashLink } from "../TxHashLink";
import { ClaimInfoCard } from "../bridge/ClaimInfoCard";
import { TransactionTypeChip } from "../bridge/TransactionTypeChip";

export function ManualClaimSuccessModal({
  isOpen,
  onClose,
  claimTx,
}: {
  isOpen: boolean;
  onClose: () => void;
  claimTx: ManualClaimTxSuccess;
}) {
  const isDeposit = claimTx.bridgeType === "deposit";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody>
          <BadgeCheckIcon className="size-24 stroke-1 text-green-500/90 fill-green-500/10 " />
          <p className="font-semibold text-large">Manual claim completed!</p>
          {/* TODO: fetch data
          
          <ClaimInfoCard
            amount={claimTx.amount}
            tokenDecimals={claimTx.tokenDecimals}
            tokenSymbol={claimTx.tokenSymbol}
          /> 
          
          */}
          <ClaimInfoCard amount={0n} tokenDecimals={10} tokenSymbol="TEST" />
          <div className="flex flex-col gap-2 w-full">
            <div className="flex items-center justify-between w-full">
              <div className="text-[#ADC0D0]">Date & time</div>
              <div className="font-semibold">{formatTimestamp(claimTx.claimTimestamp)}</div>
            </div>

            <div className="flex items-center justify-between w-full">
              <div className="text-[#ADC0D0]">Transaction Hash</div>
              <div className="font-semibold">
                <TxHashLink txHash={claimTx.claimTxHash} source={claimTx.bridgeType === "deposit" ? "l2" : "l1"} />
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type={isDeposit ? "private" : "public"} />
            </div>
          </div>
          {isDeposit && (
            <p className="text-small text-[#AEC4D3]">
              If you want to hide your balance on the Aztec Network, use Shielding feature to make them private.{" "}
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          {isDeposit ? (
            <>
              <Button fullWidth variant="bordered" color="primary" size="lg" radius="full">
                Shield tokens
              </Button>
              <Button fullWidth color="primary" size="lg" radius="full" onPress={onClose}>
                Close
              </Button>
            </>
          ) : (
            <div className="w-full">
              <Button fullWidth color="primary" size="lg" radius="full" onPress={onClose}>
                Close
              </Button>
            </div>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
